<template>
  <component
    :is="tag"
    :class="{
      'u-padding': true,
      'is-paddingless-y': !hasPaddingY,
      'is-paddingless-x': !hasPaddingX
    }"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "UPadding",
  props: {
    tag: { type: String, default: "div", required: false },
    x: { type: [Boolean, Array], default: true, required: false },
    y: { type: Boolean, default: true, required: false }
  },
  computed: {
    ...mapGetters({
      isMobile: "ui/isMobile",
      isTablet: "ui/isTablet",
      isDesktop: "ui/isDesktop",
      isWidescreen: "ui/isWidescreen",
      isFullHd: "ui/isFullHd"
    }),
    hasPaddingX() {
      if (this.$_.isBoolean(this.x)) return this.x;
      // this.x = this.x as string[];
      if (this.isMobile) return this.x.includes("mobile");
      if (this.isTablet) return this.x.includes("tablet");
      if (this.isDesktop) return this.x.includes("desktop");
      if (this.isWidescreen) return this.x.includes("widescreen");
      if (this.isFullHd) return this.x.includes("fullhd");
      return true;
    },
    hasPaddingY() {
      if (this.$_.isBoolean(this.y)) return this.y;
      // this.y = this.y as string[];
      if (this.isMobile) return this.y.includes("mobile");
      if (this.isTablet) return this.y.includes("tablet");
      if (this.isDesktop) return this.y.includes("desktop");
      if (this.isWidescreen) return this.y.includes("widescreen");
      if (this.isFullHd) return this.y.includes("fullhd");
      return true;
    }
  }
});
</script>

<style lang="scss" scoped>
.u-padding {
  padding: 0.5em;
  @include desktop {
    padding: 1em;
  }
  &.is-paddingless-y {
    padding-top: 0;
    padding-bottom: 0;
  }
  &.is-paddingless-x {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
